import React, { useState, useEffect } from "react";
// FUNCTIONS
import { convertLevelToWord } from "../../../../../functions/convertLevelToWord";

export default function InfoUserTab1({ infoPlayeurClick }) {
  const formatDate = (date) => {
    if (date && date.includes('-')) {
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    } else if (date){
      return date
    }
    else return "Pas renseigné";
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "Pas renseigné";
  
    // Supprimer tous les caractères non numériques du numéro de téléphone
    const cleanedPhoneNumber = phoneNumber.replace(/\D/g, "");
  
    // Insérer un espace entre chaque paire de chiffres
    const formattedPhoneNumber = cleanedPhoneNumber.replace(/(\d{2})(?=\d)/g, "$1 ");
  
    return formattedPhoneNumber;
  };
  
  return (
    <>
      {infoPlayeurClick?.length === 0 && <h2>Pas d'informations</h2>}
      {infoPlayeurClick?.map((user, index) => {
        if (index !== 0) return null; // Ignore tous les éléments sauf le premier
        const { name, birthDay, level, phone,email } = user;
        return (
          <div key={index} className="tab-container">
            <h2 style={{ textTransform: "uppercase" }}>
              <span>Nom :</span> {name || "Pas renseigné"}
            </h2>

            <h2>
              <span>Date de naissance :</span>{" "}
              {birthDay ? formatDate(birthDay) : "Pas renseigné"}
            </h2>
            <h2>
              <span>Niveau :</span>{" "}
              {level ? convertLevelToWord(level) : "Pas renseigné"}
            </h2>
            <h2>
              <span>Téléphone:</span>{" "}
              {phone ? formatPhoneNumber(phone) : "Pas renseigné"}{" "}
            </h2>
            <h2>
              <span>Email:</span>{" "}
              {email ? email: "Pas renseigné"}{" "}
            </h2>
          </div>
        );
      })}
    </>
  );
}
